import { CanActivateFn, Router, Data } from '@angular/router';
import { inject } from '@angular/core';

import { JwtService } from '@core/services';

export const AuthGuard: CanActivateFn = (route, state) => {

    const router = inject(Router);

    //check authentication

    try {

        JwtService.get();

    } catch {

        console.log("No valid auth token");
        return router.parseUrl('/login');

    }

    return true;

};